import { createMuiTheme } from '@material-ui/core/styles';
import * as colors from '@material-ui/core/colors';

/* Colors - names from htmlcsscolor.com,
   Variations from https://material.io/resources/color/#!/?view.left=0&view.right=0 and
   https://www.w3schools.com/colors/colors_picker.asp */

/* Colors to be used by all components (whether they are Material UI or not. */
export const bandColor      = colors.blue[50];
export const lightGrayColor = colors.grey[100];
export const orangeColor    = "#F7991E";//#1293AC";
export const gray29Color    = "#4A4A4A";
export const gray15Color    = "#262626";
export const darkGrayColor  = "#A9A9A9";
export const gray           = "#808080";
export const whiteColor     = "#FFFFFF";
export const blackColor     = "#000000";
export const hyperLinkColor = "#337AB7";
export const red            = "#FF0000";

/* World map estimates colors. */
export const noDataEstColor = "#F7F7F7";
export const estColor1      = "#FEE9C2";
export const estColor2      = "#FDDBA4";
export const estColor3      = "#F8B56D";
export const estColor4      = "#F38E2E";
export const estColor5      = "#E7112B";
export const estColor6      = "#9A0316";

export const orangeSelectedColor = "#FFD666";

export const RC_PalatinatePurple     = "#702C5A"; // primary
export const strikemasterPurpleColor = "#A05887"; // primary - lighter
export const blackberryPurpleColor   = "#420031";  // primary - dark
export const RC_HippieBlue           = "#3E8AA0"; // secondary
export const RC_LavenderBlushColor   = "#F8EDF4"; // 95% tint on palatinate purple
export const RC_ElfGreenColor        = "#139864";
export const RC_RustColor            = "#B62F0D";

export const RC_PrimaryColor   = RC_PalatinatePurple;
export const RC_SecondaryColor = RC_HippieBlue;
export const RC_BandColor      = RC_LavenderBlushColor;

export const blueSelectedColor = "#0D0B80";

export const estColors = [estColor1, estColor2, estColor3, estColor4, estColor5, estColor6];

/* Graphik Web requires the font package under src/font as well as the following two lines
   in index.html:

    <link rel="stylesheet" type="text/css" href="../src/font/1706-HHXNJJ.css">
    <link rel="stylesheet" type="text/css" href="../src/font/1707-MHDBXW.css">
*/
export const fontFamily = ["lato, sans-serif"];

export const leftIndent = 20;
export const topIndent = 10;
export const topIndentFirstCtrl = 20;
export const ctrlSpacing = 10;

export const navBtnWidth = 120;

export const labelStyle = {
    color      : RC_HippieBlue,
    fontWeight : "bold",
};

export const labelFontStyle = {
    fontFamily    : fontFamily,//["Gentona Semi Bold", 'Open Sans Condensed', "sans-serif"],
    fontWeight    : "normal",
    letterSpacing : "0.05em",
    lineHeight    : 1.15,
};

/* These are for styling non-Material UI components using the same colors that the
   Material UI components use. Thus, styles should come from Theme.js */

export const styles = {
    listItemLab: {
        fontSize: "16px",
        color: gray29Color,
        fontWeight: 500,
        fontStyle: "normal",
    },
    listItemSelectedLab: {
        fontSize: "16px",
        color: RC_HippieBlue,
        fontWeight: "bold",
        fontStyle: "normal",
    },
    listItemDisabledLab: {
        fontSize: "16px",
        color: darkGrayColor,
        fontWeight: 500,
        fontStyle: "normal",
    },
    headerLab: {
        color      : gray29Color,
        height     : 35, // needed to fit selectFacilityDiv on same line
        fontFamily : fontFamily,
        fontSize   : "28px",
        fontStyle  : "normal",
        fontWeight : "bold",
        padding    : "1% 0", // vertically center page header
    },
    questionLab: {
        color        : gray29Color,
        marginBottom : 10,
        fontFamily   : fontFamily,
        fontStyle    : "normal",
        fontWeight   : 500,
    },
    buttonLab: {
        color      : gray29Color,
        fontFamily : fontFamily,
        fontSize   : "16px",
        fontStyle  : "normal",
        fontWeight : 500,
    },
    buttonSelectedLab: {
        color      : orangeColor,
        fontFamily : fontFamily,
        fontSize   : "16px",
        fontStyle  : "normal",
        fontWeight : "bold",
    },
    buttonDisabledLab: {
        color      : darkGrayColor,
        fontFamily : fontFamily,
        fontSize   : "16px",
        fontStyle  : "normal",
        fontWeight : 500,
    },
    editBeforeButtonStyle: {
        marginBottom : 0,
    },
    editBeforeLabStyle: {
        marginBottom : 20,
    },
    comboBoxCaptionStyle : {
        color      : orangeColor,
        fontFamily : fontFamily,
        fontSize   : "12px",
        marginLeft : "20px",
    },
    comboBoxBeforeLabStyle : {
        marginBottom : 20,
    },
    accordionStyle : {
        width : "650px",
    },
    iconBeforeButtonStyle : {
        marginBottom : 20,
    },
    sheetStyle : {
        height : "225px",
        width  : "500px",
    },
    filterBox : {
        marginBottom : 5,
        marginTop    : 5,
    },
    filterGroupLabStyle : {
        marginLeft : 0,
        // height: 40,
        marginBottom: 5,
        marginTop: 0,
        fontSize: 16
    },
    filterGroupAboveComboLabStyle : {
        fontSize: 12
    },
    filterGroupLongLabStyle : {
        marginLeft : 15,
        width      : 600,
    },
};

const muiTheme = createMuiTheme({
    typography: {
        // fontFamily: 'Lato, sans-serif',
        fontFamily  : fontFamily,
        fontStretch : "normal",
        //useNextVariants: true,
    },
    palette: {
        primary: {
            main         : RC_PalatinatePurple,
            contrastText : whiteColor,
        },
        secondary: {
            main         : RC_HippieBlue,
            contrastText : whiteColor,
        }
    },
    appBar: {
        backgroundColor : gray15Color,//whiteColor,
    },
    standardSideBar : {
        backgroundColor : orangeColor, //whiteColor,//'#05225d',
        //border: 'none'
    },
    toolsSideBar : {
        backgroundColor : whiteColor,
        border          : 'none',
    },
    editor: {
        bandColor      : '#f0f6df',
        fixedRowColor  : "#9cc025",
        highlightColor : "#fff1a6",
        cellPadding    : "3"
    },
    bandColor : {
        backgroundColor : bandColor,//'e8ffdd' //'#f0f6df'
    },
    commandBar : {
        backgroundColor : colors.blue[100],//'hotpink',
        color           : blackColor,
    },
    errorTitle : {
        margin     : '0 0 10px 0',
        fontWeight : 'bold'
    },
    errorParagraph : {
        margin : '0 0 10px 0'
    },
    errorBox : {
        background   : '#EF9A9A',
        borderRadius : '5px',
        padding      : '10px',
        marginBottom : '20px'
    },
    paperAnchorDockedLeft:{
        borderRight : 'none'
    },

});

export default muiTheme;